import React, { useContext, useEffect, useState } from 'react';
import ScannerQR from '../../../components/scannerQR';
import Ficha from '../../../pages/dashboard/ficha/Ficha';
import Context from '../../../context/Context';
import ButtonsSectorPieces from '../../../pages/dashboard/ficha/components/ButtonsSectorPieces';
import OutstandingPieces from '../../../pages/dashboard/ficha/OutstandingPieces';
import { Tab, Tabs } from 'react-bootstrap';
import {
  QueryStats,
  Engineering,
  ErrorOutline,
  Search,
  Warning
} from "@mui/icons-material";
import language from '../../../nls/language.json';
import { CustomTextField } from '../../atoms/CustomTextField/CustomTextField';
import { IndustryPartsTemplate } from '../../templates/IndustryParts';
import "./styles.css";
import GSAList from '../../../pages/dashboard/ficha/components/GSAList';
import { useLocation } from 'react-router-dom';
import { getCookie } from '../../../section/cookie';

export const TabDashboard = () => {
  const [idScreen, setIdScreen] = useState(2);
  const location = useLocation();
  const cookie = getCookie("permissions");
  const gsaClaim = cookie.includes("[GSA] - Apontar pecas")

  const { isGsa } = location.state || {};

  const {
    getStatusSideBar,
    selectedCountry,
    infoPiece,
    code,
    setCode,
  } = useContext(Context);

  useEffect(() => {
    setCode(code)
    if (code !== "" && code !== undefined)
      setIdScreen(4);
  }, [code]);

  useEffect(() => {
    if (isGsa) {
      setCode(setCode);
      setIdScreen(6);

    }
  }, [])

  const body = () => {
    if (idScreen)
      switch (idScreen) {
        case 1:
          return (
            <div style={{ position: "relative", height: 0, paddingBottom: "56.25%" }} >
              {/* <iframe
                title="Produção Diaria"
                //  src="https://app.powerbi.com/reportEmbed?reportId=1600c07c-30aa-45b6-89ae-8f9da0c5b572&autoAuth=true&ctid=10f1df46-3600-406b-8233-aa54d28fe447&prompt=login"
                 src="https://app.powerbi.com/reportEmbed?reportId=0bc369e9-5b91-4cc6-85ff-d107044c9bce&autoAuth=true&prompt=login"
                style={{ position: "absolute", width: "100%", height: "100%" }}
                allowFullScreen={true}
              /> */}

              <iframe
                title="Produção Diaria Direct"
                style={{ position: "absolute", width: "100%", height: "75%" }}
                src="https://app.powerbi.com/reportEmbed?reportId=0bc369e9-5b91-4cc6-85ff-d107044c9bce&autoAuth=true&ctid=10f1df46-3600-406b-8233-aa54d28fe447"
                frameborder="0"
                allowFullScreen="true">
              </iframe>
            </div>
          );
        case 2:
          return <IndustryPartsTemplate setCode={setCode} />;
        case 3:
          return <ScannerQR setCode={setCode} />;
        case 4:
          return <Ficha data={code} setCode={setCode} />
        case 5:
          return <OutstandingPieces setCode={setCode} />
        case 6:
          return <GSAList setCode={setCode} />
      }
  };

  const handleTitle = (icon, title) => {
    return (
      <div className="d-flex flex-column align-items-center">
        {icon}
        <span className="mt-1 text-light fw-bold">{title.toUpperCase()}</span>
      </div>
    )
  }

  const iconScaleDashboard = 1.3
  return (
    <>
      <div className={`div-row-button dashboard-tabs`}>
        <Tabs
          defaultActiveKey={idScreen}
          className="mb-1"
          onSelect={(e) => {
            setCode();
            setIdScreen(Number(e))
          }}
          fill
        >
          <Tab
            eventKey={1}
            title={handleTitle(<QueryStats sx={{
              transform: `scale(${iconScaleDashboard})`,
              color: "#6aa84f"
            }} />, `${language[selectedCountry.name].Dashboard.buttonsDashboard.metas}`)}
          />
          <Tab
            eventKey={2}
            title={handleTitle(<Engineering sx={{
              transform: `scale(${iconScaleDashboard})`,
              color: "#f1c232"
            }} />, `${language[selectedCountry.name].Dashboard.buttonsDashboard.pecasSetor}`)}
            className=""
          >
            {code && (
              <div className='d-flex flex-row justify-content-between flex-wrap'>
                <ButtonsSectorPieces
                  code={code}
                  setIdScreen={setIdScreen}
                  handleTitle={handleTitle}
                />
                <CustomTextField
                  className='mt-2 mt-xl-0 text-center'
                  isLabel={false}
                  label='PEÇA'
                  value={infoPiece}
                  size='lg'
                />
              </div>
            )}
          </Tab>
          <Tab
            eventKey={3}
            title={handleTitle(<Search sx={{
              transform: `scale(${iconScaleDashboard})`,
              color: ""
            }} />, `${language[selectedCountry.name].Dashboard.buttonsDashboard.pesquisar}`)}
          >
            {code && (
              <div className='d-flex flex-row justify-content-between flex-wrap'>
                <ButtonsSectorPieces
                  code={code}
                  setIdScreen={setIdScreen}
                  handleTitle={handleTitle}
                />
                <CustomTextField
                  className='mt-2 mt-xl-0 text-center'
                  isLabel={false}
                  label='PEÇA'
                  value={infoPiece}
                  size='lg'
                />
              </div>
            )}
          </Tab>
          <Tab
            eventKey={5}
            title={handleTitle(<ErrorOutline sx={{
              transform: `scale(${iconScaleDashboard})`,
              color: "#5b5b5b"
            }} />, `${language[selectedCountry.name].Dashboard.buttonsDashboard.pecasPendentes}`)}
          />
          {gsaClaim && (
            <Tab
              eventKey={6}
              title={handleTitle(<Warning color="warning" sx={{
                transform: `scale(${iconScaleDashboard})`
              }} />, "GSA")}
            />
          )}
        </Tabs>
      </div>
      <div
        className={`app_body ${getStatusSideBar()}`}
        style={{ padding: 0, top: 85, minHeight: 700 }}
      >
        <div style={{ marginBottom: 20 }}>{body()}</div>
      </div>
    </>
  );

};